import React, { Component } from 'react';
import {
  Button,
  Card,
  Col, Row,
} from 'antd';
import { connect } from 'react-redux';
import PELFiltro from '../../../pel/containers/PELFiltro';
import { Box } from '../../../shared/components';

class PresupuestoRapidoPELPage extends Component {
  componentDidMount() {
    const { history, articulo } = this.props;
    if (articulo === undefined) {
      history.replace('/presupuestorapido');
    }
  }

  render() {
    return (
      <Row>
        <Col xs={{ span: 24 }} md={{ span: 15 }} style={{ position: 'sticky', top: '0' }}>
          <Box p="8">
            <Card>
              <PELFiltro panelesOcultos={['montura']} />
            </Card>
          </Box>
        </Col>
        <Col xs={{ span: 24 }} md={{ span: 9 }}>
          <Box p="8">
            <Card>
              <Button block type="primary">Solicitar presupuesto</Button>
            </Card>
          </Box>
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = (state) => {
  const { encargosWorkspace } = state;

  const {
    encargos,
  } = encargosWorkspace;


  let articulo;
  let encargo;

  if (encargos) {
    encargo = encargos[0];
    if (encargo) {
      const { articulos } = encargo;
      if (articulos) {
        articulo = articulos[0];
      }
    }
  }

  return {
    encargo,
    articulo,
  };
};

PresupuestoRapidoPELPage.propTypes = {};

export default connect(
  mapStateToProps,
  null,
)(PresupuestoRapidoPELPage);
